<div [formGroup]="form">
  <app-common-checkbox  [formControlName]="forceGetControlName">
    <span class="checkbox-label">{{ 'force_get' | translate }}</span>
  </app-common-checkbox>
</div>
